// extracted by mini-css-extract-plugin
export default {"footer":"styles__footer___wobDa","required":"styles__required___fzXhC"};